import { useEffect, useState } from "react";
import FormCheckbox from "../../shared/FormCheckbox";
import { useQuery } from '@tanstack/react-query';
import "react-toggle/style.css"
import { fetchGetLatestTemplateRiderComponent, fetchTemplateRiderComp, getNetworks } from "../../../utils/apiUtils";
import FormSelect from "../../shared/FormSelect";
import { SLOT_NAMES } from "../../../utils/constants";

const step = 4

const StepFour = ({ activeStep, control, errors, register, setValue, getValues }) => {
    if (activeStep !== step) return

    const [filterSelected, setFilterSelected] = useState(false)
    const template = getValues("template")
    const account = getValues("account")
    const networks = getValues("networks")
    const networkDefinitionRider = getValues("networkDefinitionRider")

    const { data: allNetworks } = useQuery({
        queryKey: ['getNetworks'],
        queryFn: getNetworks
    })

    const { data: repricerOptions } = useQuery({
        queryKey: ['getRepricer'],
        // queryFn: async () => await fetchTemplateRiderComp({
        //     category: SLOT_NAMES.REPRICER_PROVISION,
        //     //    bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
        //     benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey

        // }),
        // select: (data) => data.hits.hits.map(({ _source: { metadata } }, i) => ({
        //     value: metadata.benefitPlanRiderHccId,
        //     label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
        //     additional: metadata,
        // })),

        queryFn: async () => await fetchGetLatestTemplateRiderComponent({
            slotName: SLOT_NAMES.REPRICER_PROVISION,
            benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
            limit: 100
        }),
        select: (data) => data.rows.map((metadata, i) => ({
            value: metadata.benefitPlanRiderHccId,
            label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: metadata,
        })),

        enabled: !!template?.additional?.benefitPlanTemplateKey,
    })

    //TODO
    const { data: repricerRulesRiderOptions } = useQuery({
        queryKey: ['getRepricerRules'],
        // queryFn: async () => await fetchTemplateRiderComp({
        //     category: SLOT_NAMES.NETWORK_PRICING_DENY_BACK,
        //     //  bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
        //     benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey
        // }),
        // select: (data) => data.hits.hits
        //     .map(hit => hit._source.metadata)
        //     .filter((metadata) => !!metadata.benefitPlanRiderHccId)
        //     .map((metadata, i) => ({
        //         value: metadata.benefitPlanRiderHccId,
        //         label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
        //         additional: metadata,
        //     })),

        queryFn: async () => await fetchGetLatestTemplateRiderComponent({
            slotName: SLOT_NAMES.NETWORK_PRICING_DENY_BACK,
            benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
            limit: 100
        }),
        select: (data) => data.rows.
            map((metadata, i) => ({
                value: metadata.benefitPlanRiderHccId,
                label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
                additional: metadata,
            })),

        enabled: !!template?.additional?.benefitPlanTemplateKey,
    })

    const { data: networkRiderOptions } = useQuery({
        queryKey: ['getNetworkDefinition'],
        // queryFn: async () => await fetchTemplateRiderComp({
        //     size: 100,
        //     category: 'Network Definition',
        //     searchText: account?.label?.split(' ')?.[0],
        //     //  bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
        //     benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey

        // }),
        // select: (data) => data.hits.hits.map(({ _source: { metadata } }, i) => ({
        //     value: metadata.benefitPlanRiderHccId,
        //     label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
        //     additional: metadata,
        // })),

        queryFn: async () => await fetchGetLatestTemplateRiderComponent({
            benefitPlanRiderTypeName: 'Network Definition',
            benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
            searchText: account?.label?.split(' ')?.[0],
            limit: 100
        }),
        select: (data) => data.rows.map((metadata, i) => ({
            value: metadata.benefitPlanRiderHccId,
            label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: metadata,
        })),

        enabled: !!template?.additional?.benefitPlanTemplateKey,
    })

    useEffect(() => {
        networkDefinitionRider?.additional.benefitPlanRiderDesc.split(',').map(str => str.replace(/\D/g, "")).forEach(num => {
            setValue(`networks.${num}`, true)
        })
    }, [networkDefinitionRider])


    return (
        <>
            <p style={{ fontWeight: '600' }}>Repricer</p>
            <FormSelect
                label={''}
                name={'repricer'}
                control={control}
                options={repricerOptions}
                errors={errors}
                placeholder="Select a repricer..."
                disabled={false}
            />

            {template?.label?.includes('Traditional') ? <>
                <p style={{ fontWeight: '600' }}>Repricer Rules</p>
                <FormSelect
                    label={''}
                    name={'repricerRuleRider'}
                    control={control}
                    options={repricerRulesRiderOptions}
                    errors={errors}
                    placeholder="Select a repricer rule..."
                    disabled={false}
                />
            </> : <>
                <p style={{ fontWeight: '600' }}>Default Repricer Rules</p>

                <FormSelect
                    label={''}
                    name={'repricerRuleRiderDefault'}
                    control={control}
                    options={repricerRulesRiderOptions}
                    errors={errors}
                    placeholder="Select a repricer rule..."
                    disabled={true}
                />
            </>}

            <p style={{ fontWeight: '600' }}>Network Definition</p>
            <FormSelect
                label={''}
                name={'networkDefinitionRider'}
                control={control}
                options={networkRiderOptions}
                errors={errors}
                placeholder="Select a network..."
                disabled={false}
            />

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0rem 0rem 1rem 0rem' }}>
                <p style={{ fontWeight: '600' }}>Networks (Updates based on Network definition)</p>
                <button className="toggle-btn" onClick={() => setFilterSelected(!filterSelected)}>{filterSelected ? 'Show all' : 'Show Selected Only'} </button>
            </div>

            <div style={{ height: '80%', overflowY: 'scroll' }}>
                {allNetworks?.filter(n => filterSelected ? networks?.[n.benefitNetworkName] : true)
                    .map((network, index) => (
                        <FormCheckbox
                            key={network.benefitNetworkName}
                            label={`${network.benefitNetworkName} ${network.benefitNetworkDesc}`}
                            name={`networks.${network.benefitNetworkName}`}
                            register={register}
                            disabled={true}
                            control={control}
                        />
                    ))}
            </div >
        </>
    )
}

export default StepFour
